export class Product {
  productData = null;
  variantsAvalible = null;
  selectedVariant = null;
  option1 = "";
  option2 = "";
  option3 = "";
  quantity = 1;
  purchaseType = "onetime";
  planHandle = "";
  selectedPlan = null;
  selectedPlanAllocation = null;

  constructor($productTemplate) {
    this.setupProduct($productTemplate);
  }

  // Thanks to github user pablogiralt for the handlize function https://gist.github.com/pablogiralt/f52d27428e7501909616d1
  handlelize = (str) => {
    str = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents
      .replace(/([^\w]+|\s+)/g, "-") // Replace space and other characters by hyphen
      .replace(/\-\-+/g, "-") // Replaces multiple hyphens by one hyphen
      .replace(/(^-+|-+$)/g, "") // Remove extra hyphens from beginning or end of the string
      .toLowerCase(); // To lowercase
    return str;
  };

  formatMoney = (value) => {
    return Carbon.Money.formatMoney(value);
  };

  getSelectedVaraint = () => {
    return this.selectedVariant;
  };

  getSelectedPlan = () => {
    return this.selectedPlan;
  };

  getSelectedPlanAllocation = () => {
    return this.selectedPlanAllocation;
  };

  getOption1 = () => {
    return this.option1;
  };

  setOption1 = (newOption) => {
    this.option1 = newOption;
    return this.option1;
  };

  getOption2 = () => {
    return this.option2;
  };

  setOption2 = (newOption) => {
    this.option2 = newOption;
    return this.option2;
  };

  getOption3 = () => {
    return this.option3;
  };

  setOption3 = (newOption) => {
    this.option3 = newOption;
    return this.option3;
  };

  getPlanHandle = () => {
    return this.planHandle;
  };

  setPlanHandle = (newPlanHandle) => {
    this.planHandle = newPlanHandle;
    return this.planHandle;
  };

  getQuantity = () => {
    return this.quantity;
  };

  setQuantity = (newQuantity) => {
    this.quantity = parseInt(newQuantity);
    return this.quantity;
  };

  increaseQuantity = () => {
    this.quantity = this.quantity + 1;
    return this.quantity;
  };

  decreaseQuantity = () => {
    if (this.quantity > 1) {
      this.quantity = this.quantity - 1;
    }
    return this.quantity;
  };

  getPurchaseType = () => {
    return this.purchaseType;
  };

  setPurchaseType = (newPurchaseType) => {
    this.purchaseType = newPurchaseType;
    return this.purchaseType;
  };

  getVariantHandle = () => {
    let returnString = this.option1;
    if (this.option2 != "" && this.option2 != null) {
      returnString = `${returnString}-${this.option2}`;
      if (this.option3 != "" && this.option3 != null) {
        returnString = `${returnString}-${this.option3}`;
      }
    }
    return returnString;
  };

  getVariantById = (variantId) => {
    if (this.productData) {
      const found = this.productData.variants.find((variant) => {
        return variant.id === parseInt(variantId);
      });
      return found ? found : null;
    } else {
      return null;
    }
  };

  getVariantByHandle = (variantHandle) => {
    if (this.productData) {
      const found = this.productData.variants.find((variant) => {
        return this.handlelize(variant.title) === variantHandle;
      });
      return found ? found : null;
    } else {
      return null;
    }
  };

  setVariantById = (variantId) => {
    this.selectedVariant = this.getVariantById(variantId);
  };

  setVariantByHandle = (variantHandle) => {
    this.selectedVariant = this.getVariantByHandle(variantHandle);
  };

  setVariantByOption = (optionPosition, optionvalue) => {
    const variantHandle = this.getVariantHandle();
    this.selectedVariant = this.getVariantByHandle(variantHandle);

    if (this.selectedVariant) {
      if (this.selectedPlan?.id) {
        this.setPlanById(this.selectedPlan.id);
      }

      return this.selectedVariant;
    } else {
      const variants = this.productData.variants;

      let selectedVariant = null;

      variants.forEach((variant) => {
        switch (optionPosition) {
          case 1:
            if (this.handlelize(variant.option1) === optionvalue) {
              selectedVariant = variant;
            }
            break;
          case 2:
            if (this.handlelize(variant.option2) === optionvalue) {
              selectedVariant = variant;
            }
            break;
          case 3:
            if (this.handlelize(variant.option3) === optionvalue) {
              selectedVariant = variant;
            }
            break;
        }
      });

      this.selectedVariant = selectedVariant;
      this.setOption1(
        selectedVariant.option1
          ? this.handlelize(selectedVariant.option1)
          : null
      );
      this.setOption2(
        selectedVariant.option2
          ? this.handlelize(selectedVariant.option2)
          : null
      );
      this.setOption3(
        selectedVariant.option3
          ? this.handlelize(selectedVariant.option3)
          : null
      );
      if (this.selectedPlan?.id) {
        this.setPlanById(this.selectedPlan.id);
      }
      return this.selectedVariant;
    }
  };

  getPlanById = (planId) => {
    if (this.productData) {
      let found = null;
      this.productData.selling_plan_groups.forEach((selling_plan_group) => {
        if (!found) {
          found = selling_plan_group?.selling_plans.find((selling_plan) => {
            return parseInt(selling_plan.id) == parseInt(planId);
          });
        }
      });

      return found ? found : null;
    } else {
      return null;
    }
  };

  getPlanByHandle = (planHandle) => {
    if (this.productData) {
      const found = this.productData.selling_plan_groups[0]?.selling_plans.find(
        (selling_plan) => {
          return this.handlelize(selling_plan.name) == planHandle;
        }
      );
      return found ? found : null;
    } else {
      return null;
    }
  };

  getPlanAllocationByPlanId = (planId) => {
    if (this.selectedVariant) {
      const found = this.selectedVariant?.selling_plan_allocations.find(
        (selling_plan_allocation) => {
          return selling_plan_allocation.selling_plan_id == planId;
        }
      );
      return found ? found : null;
    } else {
      return null;
    }
  };

  setPlanByHandle = (planHandle) => {
    this.selectedPlan = this.getPlanByHandle(planHandle);
    if (this.selectedPlan) {
      this.selectedPlanAllocation = this.getPlanAllocationByPlanId(
        this.selectedPlan.id
      );
    }
  };

  setPlanById = (planId) => {
    this.selectedPlan = this.getPlanById(planId);
    if (this.selectedPlan) {
      this.selectedPlanAllocation = this.getPlanAllocationByPlanId(
        this.selectedPlan.id
      );
    }
  };

  getCurrentPrice = (format = true) => {
    if (this.purchaseType === "subscription" && this.selectedPlanAllocation) {
      if (format) {
        return this.formatMoney(
          this.selectedPlanAllocation.price * this.quantity
        );
      } else {
        return parseInt(this.selectedPlanAllocation.price * this.quantity);
      }
    } else {
      if (format) {
        return this.formatMoney(this.selectedVariant.price * this.quantity);
      } else {
        return parseInt(this.selectedVariant.price * this.quantity);
      }
    }
  };

  getSubscriptionPrice = () => {
    return this.selectedPlanAllocation
      ? this.formatMoney(this.selectedPlanAllocation.price * this.quantity)
      : null;
  };

  getOnetimePrice = () => {
    return this.formatMoney(this.selectedVariant.price * this.quantity);
  };

  getSubscriptionSavingPercentage = () => {
    return Math.round(
      100 -
        (100 / parseInt(this.selectedVariant.price)) *
          parseInt(this.selectedPlanAllocation?.price)
    );
  };

  addToCart = async () => {
    const cart = window.Carbon.Cart;
    const response = await cart.addItemToCart(
      this.selectedVariant.id,
      this.quantity,
      this.purchaseType === "subscription" && this.selectedPlanAllocation
        ? this.selectedPlanAllocation.selling_plan_id
        : null
    );
    if (response) {
      if (cart.useCartAside) {
        const $cartAsideBackground = document.querySelector(
          ".cart-aside__background"
        );
        const $cartAside =
          $cartAsideBackground.querySelector("aside.cart-aside");
        const $body = document.querySelector("body");
        $body.classList.add("overflow-y-hidden");
        $cartAsideBackground.classList.remove("pointer-events-none");
        $cartAsideBackground.classList.add("bg-black", "bg-opacity-40");
        $cartAside.classList.remove(
          "translate-x-full",
          "ponter-events-none",
          "hidden"
        );
      } else {
        window.location = `/cart`;
      }
    }
  };

  setupProduct = ($productTemplate) => {
    // Set the product JSON
    const $productJson = $productTemplate.querySelector(
      ".product-template__json"
    );

    if ($productJson) {
      this.productData = JSON.parse($productJson.textContent);
      const $productJsonAvailable = $productTemplate.querySelector(
        ".product-template__json--available"
      );
      if ($productJsonAvailable) {
        this.variantsAvalible = JSON.parse($productJsonAvailable.textContent);
        const variants = this.productData.variants.map((variant) => {
          if (this.variantsAvalible.includes(variant.id)) {
            variant.avalible = true;
          } else {
            variant.avalible = false;
          }
        });
        this.productData.variants = variants;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get("variant");
      if (variantId) {
        this.setVariantById(variantId);
        this.option1 = this.selectedVariant.option1
          ? this.handlelize(this.selectedVariant.option1)
          : "";
        this.option2 = this.selectedVariant.option2
          ? this.handlelize(this.selectedVariant.option2)
          : "";
        this.option3 = this.selectedVariant.option3
          ? this.handlelize(this.selectedVariant.option3)
          : "";
      } else {
        this.selectedVariant = this.productData.variants[0];
        this.option1 = this.selectedVariant.option1
          ? this.handlelize(this.selectedVariant.option1)
          : "";
        this.option2 = this.selectedVariant.option2
          ? this.handlelize(this.selectedVariant.option2)
          : "";
        this.option3 = this.selectedVariant.option3
          ? this.handlelize(this.selectedVariant.option3)
          : "";
      }

      const sellingPlanId = urlParams.get("selling_plan");
      if (sellingPlanId) {
        this.selectedPlan = this.setPlanById(parseInt(sellingPlanId));
      } else {
        if (this.selectedVariant?.selling_plan_allocations.length > 0) {
          this.setPlanById(
            parseInt(
              this.selectedVariant?.selling_plan_allocations[0].selling_plan_id
            )
          );
        }
      }
    }
  };
}

export default Product;
